import { NetSuiteGetProductsResponseSchema, type NetSuiteGetProductsResponse } from '@vy/api-definition';
import { INTEGRATION_PROVIDERS } from '@vy/types';
import { withDefault } from '@vy/utils';
import { QueryClient, useQuery } from 'react-query';
import { getPrivateApi } from '../../../../services/api';
import { useActivatedIntegration } from '../../../use-activated-integration';
import type { CustomUseQueryOptions } from '../../requests-types/custom-use-query-options';
import { queryKeys } from '../../../../services/query-key/query-keys';

export function useNetSuiteProducts(
  customerId?: string,
  options?: CustomUseQueryOptions<NetSuiteGetProductsResponse>,
) {
  const isNetSuiteEnabled = useActivatedIntegration(INTEGRATION_PROVIDERS.netSuite, { suspense: true });

  const isEnabledInOptions = withDefault(options?.enabled, true);
  const enabled = isEnabledInOptions && isNetSuiteEnabled;

  return useQuery(
    queryKeys.netSuiteProducts(customerId),
    () => getNetSuiteProductsQueryFunction(customerId),
    {
      ...options,
      enabled,
    },
  );
}

async function getNetSuiteProductsQueryFunction(customerId?: string) {
  const api = getPrivateApi();
  const netSuiteGetProductsResponse = await api.netSuiteGetProducts({ customerId });

  return NetSuiteGetProductsResponseSchema.parse(netSuiteGetProductsResponse);
}

export async function prefetchNetSuiteProducts(queryClient: QueryClient, customerId?: string) {
  return queryClient.prefetchQuery(queryKeys.netSuiteProducts(customerId), () =>
    getNetSuiteProductsQueryFunction(customerId),
  );
}
